import { render, staticRenderFns } from "./SimpleChipTooltip.vue?vue&type=template&id=6e61214e&"
import script from "./SimpleChipTooltip.vue?vue&type=script&lang=js&"
export * from "./SimpleChipTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports